<template>
    <div>
        <section class="bg-color-">
            <div class="container">
                <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                    <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
                    <v-btn class=float-right dark text @click="snackbar = false">Close</v-btn>
                </v-snackbar>
                <v-data-table
                    :headers="headers"
                    :items="admission_schedule_master_list"
                    class="elevation-1"
                    :search="search"
                >
                    <template v-slot:top>
                        <v-toolbar flat color="white">
                        <v-toolbar-title>Admission Schedule</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                        <v-text-field
                            v-model="search"
                            append-icon="search"
                            label="Search"
                            single-line
                            hide-details
                            class="mobile-dashboard-search"
                        ></v-text-field>
                        <span style="width: 20px"></span>
                        <v-dialog v-model="dialog" max-width="500px">
                            <template v-slot:activator="{ on }">
                                <v-btn color="headerColor" dark class="mb-2" v-on="on">Add Admission Schedule</v-btn>
                            </template>
                            <v-card>
                                <v-form v-model="valid">
                                    <v-card-title>
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>
                                    <v-card-text>
                                        <v-container>
                                            <v-row dense>
                                                <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                                                    <v-autocomplete
                                                        dense
                                                        :items="admissionStepMaster_list"
                                                        v-model="addedItem.admissionStepMaster"
                                                        item-value="id"
                                                        item-text="stepname"
                                                        label="*Select Admission Step Master"
                                                        prepend-inner-icon="mdi-view-list"
                                                        outlined
                                                        persistent-hint
                                                        :rules="[v => !!v || 'required']"
                                                        :error-messages="error.admissionStepMaster?'Please Select Admission Step Master':''"
                                                    ></v-autocomplete>
                                                </v-col>
                                                <v-col cols="12" v-if="editedIndex != -1">
                                                    <v-autocomplete
                                                        dense
                                                        :items="admissionStepMaster_list"
                                                        v-model="editedItem.admissionStepMaster"
                                                        label="*Select Admission Step Master Edit"
                                                        prepend-inner-icon="mdi-view-list"
                                                        item-value="stepname"
                                                        item-text="stepname"
                                                        outlined
                                                        persistent-hint
                                                        :rules="[v => !!v || 'required']"
                                                        :error-messages="error.admissionStepMaster?'Please Select Admission Step Master':''"
                                                    ></v-autocomplete>
                                                </v-col>

                                                <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                                                    <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field
                                                        dense
                                                        v-model="addedItem.startDate"
                                                        label="*Start Date"
                                                        prepend-inner-icon="mdi-calendar"
                                                        outlined
                                                        readonly
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        ></v-text-field>
                                                    </template>
                                                    <v-date-picker
                                                        dense
                                                        label="*Start Date"
                                                        outlined
                                                        v-model="addedItem.startDate"
                                                        @input="menu1 = false"
                                                        min="1950-01-01"
                                                    ></v-date-picker>
                                                    </v-menu>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                                                    <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-text-field
                                                                dense
                                                                v-model="editedItem.start_date"
                                                                label="*Start Date"
                                                                prepend-inner-icon="mdi-calendar"
                                                                outlined
                                                                readonly
                                                                v-bind="attrs"
                                                                v-on="on"
                                                            ></v-text-field>
                                                        </template>
                                                        <v-date-picker
                                                            dense
                                                            label="*Start Date"
                                                            outlined
                                                            v-model="editedItem.start_date"
                                                            @input="menu1 = false"
                                                            min="1950-01-01"
                                                        ></v-date-picker>
                                                    </v-menu>
                                                </v-col>

                                                <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                                                    <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field
                                                        dense
                                                        v-model="addedItem.endDate"
                                                        label="*End Date"
                                                        prepend-inner-icon="mdi-calendar"
                                                        outlined
                                                        readonly
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        ></v-text-field>
                                                    </template>
                                                    <v-date-picker
                                                        dense
                                                        label="*End Date"
                                                        outlined
                                                        v-model="addedItem.endDate"
                                                        @input="menu2 = false"
                                                        :min="addedItem.startDate"
                                                    ></v-date-picker>
                                                    </v-menu>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                                                    <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-text-field
                                                                dense
                                                                v-model="editedItem.end_date"
                                                                label="*End Date"
                                                                prepend-inner-icon="mdi-calendar"
                                                                outlined
                                                                readonly
                                                                v-bind="attrs"
                                                                v-on="on"
                                                            ></v-text-field>
                                                        </template>
                                                        <v-date-picker
                                                            dense
                                                            label="*End Date"
                                                            outlined
                                                            v-model="editedItem.end_date"
                                                            @input="menu2 = false"
                                                            :min="editedItem.startDate"
                                                        ></v-date-picker>
                                                    </v-menu>
                                                </v-col>

                                                <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                                                    <v-text-field 
                                                        dense                        
                                                        outlined
                                                        v-model="addedItem.sortOrder"
                                                        prepend-inner-icon="edit"
                                                        label="*Sort Order"
                                                        :rules="[v => !!v || 'required']" 
                                                        persistent-hint
                                                        :error-messages="error.sortOrder?'Please Enter Sort Order':''"
                                                    >
                                                    </v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                                                    <v-text-field 
                                                        dense                        
                                                        outlined
                                                        v-model="editedItem.sortOrder"
                                                        prepend-inner-icon="edit" 
                                                        label="*Sort Order"
                                                        :rules="[v => !!v || 'required']" 
                                                        persistent-hint
                                                        :error-messages="error.sortOrder?'Please Enter Sort Order':''"
                                                    >
                                                    </v-text-field>
                                                </v-col>

                                                <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                                                    <v-autocomplete
                                                        dense
                                                        :items="program_list"
                                                        v-model="addedItem.program"
                                                        label="*Select Program"
                                                        item-value="id"
                                                        item-text="name"
                                                        prepend-inner-icon="mdi-view-list"
                                                        outlined
                                                        persistent-hint
                                                        :rules="[v => !!v || 'required']"
                                                        :error-messages="error.program?'Please Select Program':''"
                                                    ></v-autocomplete>
                                                </v-col>
                                                <v-col cols="12" v-if="editedIndex != -1">
                                                    <v-autocomplete
                                                        dense
                                                        :items="program_list"
                                                        v-model="editedItem.program"
                                                        label="*Select Program"
                                                        item-value="name"
                                                        item-text="name"
                                                        prepend-inner-icon="mdi-view-list"
                                                        outlined
                                                        persistent-hint
                                                        :rules="[v => !!v || 'required']"
                                                        :error-messages="error.program?'Please Select Program':''"
                                                    ></v-autocomplete>
                                                </v-col>

                                                <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                                                    <v-autocomplete
                                                        dense
                                                        :items="year_list"
                                                        v-model="addedItem.year"
                                                        label="*Select Year"
                                                        item-value="id"
                                                        item-text="year"
                                                        prepend-inner-icon="mdi-view-list"
                                                        outlined
                                                        persistent-hint
                                                        :rules="[v => !!v || 'required']"
                                                        :error-messages="error.year?'Please Select Year':''"
                                                    ></v-autocomplete>
                                                </v-col>
                                                <v-col cols="12" v-if="editedIndex != -1">
                                                    <v-autocomplete
                                                        dense
                                                        :items="year_list"
                                                        v-model="editedItem.year"
                                                        label="*Select Year"
                                                        item-value="year"
                                                        item-text="year"
                                                        prepend-inner-icon="mdi-view-list"
                                                        outlined
                                                        persistent-hint
                                                        :rules="[v => !!v || 'required']"
                                                        :error-messages="error.year?'Please Select Year':''"
                                                    ></v-autocomplete>
                                                </v-col>

                                                <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                                                    <v-autocomplete
                                                        dense
                                                        :items="academicYear_list"
                                                        v-model="addedItem.ay"
                                                        label="*Select Academic Year"
                                                        item-value="id"
                                                        item-text="ay"
                                                        prepend-inner-icon="mdi-view-list"
                                                        :rules="[v => !!v || 'required']"
                                                        outlined
                                                        persistent-hint
                                                    ></v-autocomplete>
                                                </v-col>
                                                <v-col cols="12" v-if="editedIndex != -1">
                                                    <v-autocomplete
                                                        dense
                                                        :items="academicYear_list"
                                                        v-model="editedItem.academicYear"
                                                        label="*Select Academic Year"
                                                        item-value="ay"
                                                        item-text="ay"
                                                        prepend-inner-icon="mdi-view-list"
                                                        :rules="[v => !!v || 'required']"
                                                        outlined
                                                        persistent-hint
                                                    ></v-autocomplete>
                                                </v-col>

                                                <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                                                    <v-autocomplete
                                                        dense
                                                        :items="org_list"
                                                        v-model="addedItem.org"
                                                        label="*Select Organization"
                                                        prepend-inner-icon="mdi-view-list"
                                                        item-value="id"
                                                        item-text="organization_code"
                                                        outlined
                                                        persistent-hint
                                                        :rules="[v => !!v || 'required']"
                                                        :error-messages="error.org?'Please Select Organization':''"
                                                    ></v-autocomplete>
                                                </v-col>
                                                <v-col cols="12" v-if="editedIndex != -1">
                                                    <v-autocomplete
                                                        dense
                                                        :items="org_list"
                                                        v-model="editedItem.organization"
                                                        label="*Select Organization"
                                                        item-value="organization_code"
                                                        item-text="organization_code"
                                                        prepend-inner-icon="mdi-view-list"
                                                        outlined
                                                        persistent-hint
                                                        :rules="[v => !!v || 'required']"
                                                        :error-messages="error.org?'Please Select Organization':''"
                                                    ></v-autocomplete>
                                                </v-col>
                                                
                                                <v-col cols="12" sm="6" md="4">
                                                    <v-checkbox
                                                        dense
                                                        v-if="editedIndex != -1"
                                                        v-model="editedItem.isActive"
                                                        color="success"
                                                        label="isActive"
                                                    ></v-checkbox>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="headerColor" outlined text @click="close">Cancel</v-btn>
                                        <v-btn @click="save" :disabled="!valid">Save</v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-card>
                        </v-dialog>
                        </v-toolbar>
                    </template>
                    <template v-slot:[`item.isActive`]="{ item }">
                        <span v-if="item.isActive">
                            <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                        </span>
                        <span v-else>
                            <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                        </span>
                    </template>
                    <template v-slot:[`item.action`]="{ item }">
                        <div>
                        <v-avatar style size="25" class="edit-avatar">
                            <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
                        </v-avatar>
                        </div>
                    </template>
                </v-data-table>
                <v-overlay :value="overlay">
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                </v-overlay>
            </div> <!--/. container -->
        </section> <!--/. section -->
    </div>
</template>

<script>
import axios from "axios";
export default {
    name: "master-admission-schedule",
    data: () => ({
        valid: false,
        menu1: false,
        menu2: false,
        overlay: false,
        snackbar_msg: "",
        color: "",
        snackbar: false,
        search: "",
        dialog: false,
        headers: [
            { text: "Sr.No", value: "cri_srNo" },
            {
                text: "Admission Step Master",
                align: "left",
                sortable: true,
                value: "admissionStepMaster"
            },
            {
                text: "Start Date",
                align: "left",
                sortable: true,
                value: "start_date"
            },
            {
                text: "End Date",
                align: "left",
                sortable: true,
                value: "end_date"
            },
            {
                text: "Sort Order",
                align: "left",
                sortable: true,
                value: "sortOrder"
            },
            {
                text: "Program",
                align: "left",
                sortable: true,
                value: "program"
            },
            {
                text: "Year",
                align: "left",
                sortable: true,
                value: "year"
            },
            {
                text: "Academic Year",
                align: "left",
                sortable: true,
                value: "academicYear"
            },
            {
                text: "Organization",
                align: "left",
                sortable: true,
                value: "organization"
            },
            {
                text: "Active",
                align: "left",
                sortable: true,
                value: "isActive"
            },
            {
                text: "Actions",
                value: "action",
                sortable: false
            }
        ],
        admission_schedule_master_list: [],
        academicYear_list: [],
        program_list: [],
        year_list: [],
        admissionStepMaster_list: [],
        org_list: [],
        editedIndex: -1,
        addedItem: {
            application_id: "",
            admissionStepMaster: "",
            startDate: "",
            endDate: "",
            sortOrder: "",
            program: "",
            year: "",
            ay: "",
            org: "",
        },
        editedItem: {
            application_id: "",
            id: "",
            admissionStepMaster: "",
            start_date: "",
            end_date: "",
            sortOrder: "",
            program: "",
            year: "",
            academicYear: "",
            organization: "",
            isActive:true,
        },
        defaultItem: {
            id: "",
            admissionStepMaster: "",
            start_date: "",
            end_date: "",
            sortOrder: "",
            program: "",
            year: "",
            academicYear: "",
            organization: "",
        },
        error: {
            admissionStepMaster:false,
            startDate:false,
            endDate:false,
            sortOrder:false,
            year:false,
            ay:false,
            org:false,
        },
        orgId: {
            org: "",
        }
    }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Admission Schedule" : "Edit Admission Schedule";
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    }
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    showSnackbar(clr, msg) {
        this.snackbar = true;
        this.color = clr;
        this.snackbar_msg = msg;
    },//end of function
    editItem(item) {
        //alert(JSON.stringify(item))
        this.editedIndex = this.admission_schedule_master_list.indexOf(item);
        this.editedItem = Object.assign({}, item);
        //alert(JSON.stringify(this.editedItem.year))
        this.dialog = true;
    },//end of function
    onLoad() {
      this.overlay = true;
      this.orgId.org = localStorage.getItem("orgid");
      axios
        .post("/Master/fetchAdmissionSchedule",this.orgId)
        .then(res => {
            if (res.data.msg == "200") {
                //window.alert(res.data.msg)
                if ((this.load = true)) {
                    this.admission_schedule_master_list = res.data.admission_schedule_master_list;
                    this.academicYear_list = res.data.academicYear_list;
                    this.program_list = res.data.program_list;
                    this.year_list = res.data.year_list;
                    this.admissionStepMaster_list = res.data.admissionStepMaster_list;
                    this.org_list = res.data.org_list;
                    this.overlay = false;
                }
            } 
            else 
            {
                //window.console.log(res.data.msg);
            }
        })
        .catch(error => {
            this.showSnackbar("error", "Something went wrong. Please try again.");
        })
        .finally(() => {
            "use strict";
            var overlay = false;
        });
    },//end of function 
    close() {
        this.dialog = false;
        setTimeout(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        }, 300);
    },//end of function
    save() {
        if (this.editedIndex > -1) {
            this.editedItem.application_id = localStorage.getItem("loginid");
            axios
            .post("/Master/editAdmissionSchedule", this.editedItem)
            .then(res => {
                if (res.data.status.code == "SUCCESS") {
                    Object.assign(this.admission_schedule_master_list[this.editedIndex],this.editedItem);
                    this.showSnackbar("#673ab7","Admission Schedule Updated Successfully.");
                } 
                else if (res.data.status.code == "NA") {
                    this.showSnackbar("error", res.data.status.message);
                }
                this.onLoad();
            })
            .catch(error => {
                this.showSnackbar("error", "Something went wrong. Please try again.");
            });
            this.close();   
        } 
        else {
            this.addedItem.application_id = localStorage.getItem("loginid");
            axios
            .post("/Master/saveAdmissionSchedule", this.addedItem)
            .then(res => {
                if (res.data.status.code == "SUCCESS") {
                    this.admission_schedule_master_list.push(this.addedItem);
                    this.showSnackbar("#673ab7","Admission Schedule Added Successfully.");
                    this.onLoad();
                } 
                else if (res.data.status.code == "NA") {
                    this.showSnackbar("error", "Admission Schedule Already Present.");
                }
                this.onLoad();
            })
            .catch(error => {
                this.showSnackbar("error", "Something went wrong. Please try again.");
            });
            this.close();
        }
    },//end of function
    isValidated() {
      if (this.editedItem.admissionStepMaster) {
        return true;
      } 
      else {
        if (!this.editedItem.admissionStepMaster) {
          this.error.admissionStepMaster = true;
        }
        return false;
      }
    } //end of function
  }
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}

.v-icon-size {
  font-size: 20px;
}

.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}

.edit-avatar:hover {
  background-color: #b0bec5;
}

.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}

.edit-v-icon:hover {
  color: white;
}
</style>